// import React, { useState } from "react";
// import { Image, Button } from "react-bootstrap";
// import ReactStars from "react-rating-stars-component";
// import moment from "moment";
// import isEmpty from "../../../../../../store/validation/is-Empty";

// export const VendorRatingReviewTablebody = (
//   props
//   //   {
//   //   sectionFiveCss,
//   //   reviewText,
//   //   userImage,
//   //   userName,
//   //   likeComments,
//   //   chatComments,
//   //   disslikeComments,
//   //   totalRateing,
//   //   dateTime,
//   //   reviewData.serviceType,
//   //   reviewData.walkinType,
//   //   requestId,
//   //   onClickShowView,
//   // }
// ) => {
//   const [TrDetail, setTrDetail] = useState({ TrDetail: false });
//   const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
//   return (
//     <React.Fragment>
//       <tbody>
//         {/* enLeftGReenLine */}
//         <tr className="enLeftYellowLine  super_admin_all_users_table_body super-admin-suggestion-table-body ">
//           <td style={{ width: "15%" }}>
//             <div className="super-admin-suggestion-table-body-boxone">
//               <div className="super-admin-suggestion-imageBoxOne enIMG33">
//                 <Image
//                   fluid
//                   src={props.reviewData.user_id.profile_photo}
//                   alt="Icon"
//                 />
//               </div>
//               <div className="super-admin-suggestion-imageBoxTwo">
//                 <div className="f12-400">
//                   {props.reviewData.user_id.first_name +
//                     " " +
//                     props.reviewData.user_id.last_name}
//                 </div>
//               </div>
//             </div>
//           </td>
//           <td style={{ width: "20%" }}>
//             <div className="f12-500 mb-1">{props.reviewData.rating} Stars</div>
//             <ReactStars
//               count={5}
//               value={props.reviewData.rating}
//               disabled={true}
//               size={22}
//               half={true}
//               emptyIcon={<i className="fa fa-star-o"></i>}
//               halfIcon={<i className="fa fa-star-half-alt"></i>}
//               fullIcon={<i className="fa fa-star"></i>}
//               color2={"#FDD400"}
//             />
//             <div className="f10-500 mt-1">
//               {moment(props.reviewData.createdAt).format("Do MMM YYYY")}{" "}
//               {moment(props.reviewData.createdAt).format("hh:mm A")}
//             </div>
//           </td>
//           <td style={{ width: "40%" }}>
//             <div className="rating-review-table-body-sectiontwo ">
//               <span className="f12-400 enEllips3">
//                 {props.reviewData.review}
//               </span>
//               <Button
//                 className="f12-400 text-red p-0"
//                 variant="link"
//                 onClick={props.onClickShowView}
//               >
//                 Read More
//               </Button>
//               <div className="d-flex align-items-center pt-2">
//                 <div className="d-flex align-items-center">
//                   <div className="opacity5">
//                     <Image
//                       fluid
//                       alt="User Photo"
//                       width="12px"
//                       src={require("../../../../../../assets/images/superadmin/like.svg")}
//                     />
//                   </div>
//                   <div className="rating-review-table-body-usertextone">
//                     <div className="f10-400 mx-2">
//                       {props.reviewData.likes.length}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="d-flex align-items-center">
//                   <div className="opacity5">
//                     <Image
//                       fluid
//                       alt="User Photo"
//                       width="12px"
//                       src={require("../../../../../../assets/images/superadmin/disslike.svg")}
//                     />
//                   </div>
//                   <div className="rating-review-table-body-usertextone">
//                     <div className="f10-400 mx-2">
//                       {props.reviewData.dislikes.length}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="d-flex align-items-center">
//                   <div className="opacity5">
//                     <Image
//                       fluid
//                       alt="User Photo"
//                       width="12px"
//                       src={require("../../../../../../assets/images/superadmin/chat.svg")}
//                     />
//                   </div>
//                   <div className="rating-review-table-body-usertextone">
//                     <div className="f10-400 mx-2">
//                       {props.reviewData.comment.length}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </td>
//           <td style={{ width: "15%" }}>
//             <div className="d-flex align-items-center">
//               <div className="image-box-new mr-2">
//                 <Image
//                   fluid
//                   src={
//                     props.reviewData.serviceType === "RESERVATION"
//                       ? require("../../../../../../assets/images/seatingImages/reservationBlack.png")
//                       : props.reviewData.serviceType === "SEATING" &&
//                         props.reviewData.walkinType === true
//                       ? require("../../../../../../assets/images/seatingImages/chairBlack.png")
//                       : props.reviewData.serviceType === "SEATING" &&
//                         props.reviewData.walkinType === false
//                       ? require("../../../../../../assets/images/ActionImages/clock-circular-outline.svg")
//                       : null
//                   }
//                 />
//               </div>
//               <div>
//                 <div className="f12-500">
//                   {props.reviewData.serviceType === "RESERVATION"
//                     ? "RESERVATION"
//                     : props.reviewData.serviceType === "SEATING" &&
//                       props.reviewData.walkinType === true
//                     ? "Walkin"
//                     : props.reviewData.serviceType === "SEATING" &&
//                       props.reviewData.walkinType === false
//                     ? "Waitlist"
//                     : null}
//                 </div>
//                 <span className="f10-400">{props.reviewData.requestId}</span>
//               </div>
//             </div>
//           </td>
//           {TrDetail.TrDetail && (
//             <div className="d-flex align-items-center mt-3">
//               <div>
//                 <Button
//                   variant="link"
//                   className="enIconBtn mr-3"
//                   onClick={props.onClickShowView}
//                 >
//                   <Image
//                     fluid
//                     alt="View"
//                     title="View"
//                     src={require("../../../../../../assets/images/UserManagement/eye.svg")}
//                   />
//                 </Button>
//                 <div className="f10-500 mt-1">Approvd</div>
//               </div>
//               <div>
//                 <Button
//                   variant="link"
//                   className="enIconBtn"
//                   onClick={props.onClickShowView}
//                 >
//                   <Image
//                     fluid
//                     alt="View"
//                     title="View"
//                     src={require("../../../../../../assets/images/UserManagement/close.svg")}
//                   />
//                 </Button>
//                 <div className="f10-500 mt-1">Hide Message</div>
//               </div>
//               {/* <Button
//                   variant="link"
//                   className="enIconBtn"
//                   onClick={onClickHideMessage}
//                 >
//                   <Image
//                     fluid
//                     alt="View"
//                     title="View"
//                     width="16px"
//                     src={require("../../../../../../assets/images/UserManagement/checkmark.svg")}
//                   />
//                 </Button>
//                 <div
//                   className="f10-500 mt-1 cursor"
//                   onClick={onClickHideMessage}
//                 >
//                   Unhide Message
//                 </div> */}
//             </div>
//           )}
//         </tr>
//       </tbody>
//     </React.Fragment>
//   );
// };

import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Image, Button } from "react-bootstrap";
import ReactStars from "react-rating-stars-component";
import moment from "moment";
import {
  update_diner_review_status,
  get_vendor_single_rating_review,
} from "../../../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";

export const VendorRatingReviewTablebody = (props) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => {
    return state.auth.user.accessToken;
  });
  const onClickHideMessage = (data) => (e) => {
    const diner_id = data._id;
    const formData = {
      status: !data.status,
    };
    dispatch(
      update_diner_review_status(formData, token, diner_id, onCallBackFunc)
    );
  };

  const onCallBackFunc = () => {
    dispatch(get_vendor_single_rating_review(props.reviewData, 1));
  };

  return (
    <React.Fragment>
      <tbody>
        {/* enLeftGReenLine */}
        <tr className="enLeftYellowLine  super_admin_all_users_table_body super-admin-suggestion-table-body ">
          <td style={{ width: "15%" }}>
            <div className="super-admin-suggestion-table-body-boxone">
              <div className="super-admin-suggestion-imageBoxOne enIMG33">
                <Image
                  fluid
                  src={
                    props.reviewData.user_id &&
                    props.reviewData.user_id.profile_photo
                  }
                  alt="Icon"
                />
              </div>
              <div className="super-admin-suggestion-imageBoxTwo">
                <div className="f12-400">
                  {props.reviewData.user_id &&
                    props.reviewData.user_id.first_name +
                      " " +
                      props.reviewData.user_id.last_name}
                </div>
              </div>
            </div>
          </td>
          <td style={{ width: "15%" }}>
            <div className="f12-500 mb-1">
              {props.reviewData && props.reviewData.rating} Stars
            </div>
            <ReactStars
              count={5}
              value={props.reviewData.rating}
              disabled={true}
              size={22}
              half={true}
              emptyIcon={<i className="fa fa-star-o"></i>}
              halfIcon={<i className="fa fa-star-half-alt"></i>}
              fullIcon={<i className="fa fa-star"></i>}
              color2={"#FDD400"}
            />
            <div className="f10-500 mt-1">
              {moment(props.reviewData.createdAt).format("Do MMM YYYY")}
              {moment(props.reviewData.createdAt).format("hh:mm A")}
            </div>
          </td>
          <td style={{ width: "40%" }}>
            <div className="rating-review-table-body-sectiontwo ">
              <span className="f12-400 enEllips3">
                {props.reviewData.review}
              </span>
              {/* <Button
                className="f12-400 text-red p-0"
                variant="link"
                onClick={props.onClickShowView}
              >
                Read More
              </Button> */}
              <div className="d-flex align-items-center pt-2">
                <div className="d-flex align-items-center">
                  <div className="opacity5">
                    <Image
                      fluid
                      alt="User Photo"
                      width="12px"
                      src={require("../../../../../../assets/images/superadmin/like.svg")}
                    />
                  </div>
                  <div className="rating-review-table-body-usertextone">
                    <div className="f10-400 mx-2">
                      {props.reviewData.likes.length}
                    </div>
                  </div>
                </div>

                <div className="d-flex align-items-center">
                  <div className="opacity5">
                    <Image
                      fluid
                      alt="User Photo"
                      width="12px"
                      src={require("../../../../../../assets/images/superadmin/disslike.svg")}
                    />
                  </div>
                  <div className="rating-review-table-body-usertextone">
                    <div className="f10-400 mx-2">
                      {props.reviewData.dislikes.length}
                    </div>
                  </div>
                </div>

                <div className="d-flex align-items-center">
                  <div className="opacity5">
                    <Image
                      fluid
                      alt="User Photo"
                      width="12px"
                      src={require("../../../../../../assets/images/superadmin/chat.svg")}
                    />
                  </div>
                  <div className="rating-review-table-body-usertextone">
                    <div className="f10-400 mx-2">
                      {props.reviewData.comment.length}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td style={{ width: "15%" }}>
            <div className="d-flex align-items-center">
              <div className="image-box-new mr-2">
                {/* <Image
                  fluid
                  src={
                    props.reviewData.diner_id.service_type !== null &&
                    props.reviewData.diner_id.service_type !== undefined
                      ? props.reviewData.diner_id.service_type === "RESERVATION"
                        ? require("../../../../../../assets/images/seatingImages/reservationBlack.png")
                        : props.reviewData.diner_id.service_type ===
                            "SEATING" &&
                          props.reviewData.diner_id.isWalkIn === true
                        ? require("../../../../../../assets/images/seatingImages/chairBlack.png")
                        : props.reviewData.diner_id.service_type ===
                            "SEATING" &&
                          props.reviewData.diner_id.isWalkIn === false
                        ? require("../../../../../../assets/images/ActionImages/clock-circular-outline.svg")
                        : null
                      : require("../../../../../../assets/images/seatingImages/reservationBlack.png")
                  }
                /> */}
              </div>
              <div>
                <div className="f12-500">
                  {/* {props.reviewData.diner_id.service_type === "RESERVATION"
                    ? "RESERVATION"
                    : props.reviewData.diner_id.service_type === "SEATING" &&
                      props.reviewData.diner_id.isWalkIn === true
                    ? "Walkin"
                    : props.reviewData.diner_id.service_type === "SEATING" &&
                      props.reviewData.diner_id.isWalkIn === false
                    ? "Waitlist"
                    : null} */}
                </div>
                <span className="f10-400">
                  #{props.reviewData.diner_request_id}
                </span>
              </div>
            </div>
          </td>
          <td style={{ width: "15%" }}>
            <div className="d-flex align-items-center mt-3">
              <div>
                <Button
                  variant="link"
                  className="enIconBtn"
                  onClick={onClickHideMessage(props.reviewData)}
                >
                  <Image
                    fluid
                    alt="hide"
                    title="hide"
                    src={require("../../../../../../assets/images/UserManagement/close.svg")}
                  />
                </Button>
                <div
                  className="f10-500 mt-1 cursor"
                  onClick={onClickHideMessage(props.reviewData)}
                >
                  {props.reviewData.status === true
                    ? "Hide Message"
                    : "Unhide Message"}
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};
